var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.transferPageShow
    ? _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "transfer-right-body",
          attrs: {
            id: "cloudTransfer",
            "element-loading-background": "rgba(0, 0, 0, 0.05)"
          }
        },
        [
          _c("div", { staticClass: "task-top" }, [
            _c("div", { staticClass: "task-top-position" }, [
              _c("div", { staticClass: "transfer-name" }, [
                _vm._v(_vm._s(_vm.$t("language.teamTransfer.teamTransfer")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "transfer-description" }, [
                _vm._v(
                  _vm._s(_vm.$t("language.teamTransfer.transferMultiple")) +
                    "\r\n                "
                ),
                _c(
                  "span",
                  {
                    staticClass:
                      "icon-util question-mark question-mark-position"
                  },
                  [
                    _c(
                      "div",
                      {
                        class:
                          _vm.$i18n.locale == "france"
                            ? "up-prompt"
                            : "up-prompt"
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("language.teamTransfer.businessCloud"))
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "task-middle" }, [
            _c("div", { staticClass: "team-box-position" }, [
              _c(
                "div",
                { staticClass: "team-transfer-box", class: _vm.boxFrom },
                [
                  _c("div", { staticStyle: { height: "100%" } }, [
                    _c("div", { staticClass: "team-box-title" }, [
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "title-txt-team task-operating-none" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("language.cloudTransfer.from"))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.fromDrives.length
                          ? _c("div", {
                              staticClass: "team-refresh icon-util edit",
                              on: {
                                click: function($event) {
                                  return _vm.transferSourceDialogShow("inner")
                                }
                              }
                            })
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.fromDrives.length
                      ? _c(
                          "div",
                          { staticClass: "team-box-body" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "team-box-item",
                                staticStyle: {
                                  height: "50Px",
                                  float: "left",
                                  width: "100%"
                                }
                              },
                              [
                                _c("div", {
                                  staticClass:
                                    "task-type task-icon icon-normal-drive",
                                  class: [
                                    _vm.fromDrives.length
                                      ? _vm.fromDrives[0].appName + "_big"
                                      : ""
                                  ]
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "source-title" }, [
                                  _vm._v(_vm._s(_vm.fromDrives[0].name))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-scrollbar",
                              {
                                staticStyle: {
                                  height: "calc(100% - 50Px)",
                                  width: "100%"
                                }
                              },
                              _vm._l(_vm.fromDrives[0].data.members, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "ul",
                                  {
                                    key: index,
                                    staticClass: "team-box-item team-box-all"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "item-line",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.open(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "icon-util not-open-position pull-triangle-position ",
                                          class: [
                                            item.open
                                              ? "down-triangle down-triangle-position"
                                              : "pull-triangle"
                                          ],
                                          staticStyle: {
                                            cursor: "pointer",
                                            width: "7%",
                                            left: "10Px"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.open(item)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "box-litem",
                                            staticStyle: {
                                              cursor: "pointer",
                                              width: "82%",
                                              left: "10Px",
                                              position: "relative"
                                            },
                                            attrs: { title: item.domain },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.open(item)
                                              },
                                              dblclick: function($event) {
                                                $event.stopPropagation()
                                                return _vm.open(item)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.domain) + "  "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(item.items, function(litem, index) {
                                      return _c(
                                        "ul",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: item.open,
                                              expression: "item.open"
                                            }
                                          ],
                                          key: index,
                                          staticClass: "team-box-item"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "item-line",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.checkSource(litem)
                                                }
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "icon-util  team-radio-position",
                                                class: [
                                                  _vm.checkSourceItem == litem
                                                    ? "check-radio"
                                                    : "radio"
                                                ],
                                                staticStyle: {
                                                  "margin-left": "8%",
                                                  float: "left",
                                                  top: "14Px"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.checkSource(
                                                      litem
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "box-litem",
                                                  attrs: { title: litem.email },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.checkSource(
                                                        litem
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(litem.email) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.fromDrives.length
                      ? _c(
                          "div",
                          {
                            staticClass: "add-transfer-txt team-cursor",
                            on: {
                              click: function($event) {
                                return _vm.transferSourceDialogShow("out")
                              }
                            }
                          },
                          [
                            _c("div", {
                              staticClass:
                                "add-team-transfer add-team-icon-position"
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "cloud-txt" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.teamTransfer.sourceCloud")
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.autoLoading,
                      expression: "autoLoading"
                    }
                  ],
                  staticClass: "team-task-box-middle"
                },
                [
                  _c("div", { staticClass: "team-box-title" }, [
                    _c(
                      "div",
                      {
                        staticClass: "team-title-item",
                        staticStyle: { "padding-left": "10px", width: "45%" }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("language.teamTransfer.sourceAccount"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "team-title-item" }, [
                      _vm._v(
                        _vm._s(_vm.$t("language.teamTransfer.targetAccounts"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "team-last-item" }, [
                      _c(
                        "div",
                        {
                          staticStyle: { float: "right", width: "10%" },
                          on: {
                            click: function($event) {
                              return _vm.deletePair()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "team-icon-position trash-position",
                            class: [_vm.pair.length ? "delete" : "delete-dis"]
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "auto-all" }, [
                        _c("div", { staticClass: "trash-right" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { width: "20%", float: "right" } },
                          [
                            _c("div", {
                              staticClass: " dropdown-icon ",
                              class: _vm.getDropDown(),
                              staticStyle: {
                                position: "relative",
                                top: "6Px",
                                float: "right",
                                left: "-8px"
                              },
                              on: {
                                mouseover: function($event) {
                                  return _vm.showMenu()
                                },
                                mouseleave: function($event) {
                                  ;(_vm.showDown = true),
                                    (_vm.boxmenuShow = false)
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: [
                              !_vm.fromDrives.length ||
                              !_vm.aimDrives.length ||
                              _vm.autoLoading
                                ? "auto-match-dis"
                                : "auto-match"
                            ],
                            attrs: {
                              title: _vm.$t("language.teamTransfer.batchMatch")
                            },
                            on: {
                              mouseover: function($event) {
                                return _vm.showMenu()
                              },
                              mouseleave: function($event) {
                                ;(_vm.showDown = true),
                                  (_vm.boxmenuShow = false)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\r\n                               " +
                                _vm._s(
                                  _vm.$t("language.teamTransfer.batchMatch")
                                ) +
                                "\r\n                               "
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.boxmenuShow,
                                    expression: "boxmenuShow"
                                  }
                                ],
                                staticClass: "csv-box"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "csv-item",
                                    attrs: {
                                      title: _vm.$t(
                                        "language.teamTransfer.autoMatch"
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.autoMatch()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.teamTransfer.autoMatch"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "csv-item",
                                    attrs: {
                                      title: _vm.$t(
                                        "language.teamTransfer.uploadCSV"
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.openUpload()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.teamTransfer.uploadCSV"
                                        )
                                      ) +
                                        "\r\n                                         "
                                    ),
                                    _c("input", {
                                      ref: "uploadFile",
                                      staticStyle: { display: "none" },
                                      attrs: { type: "file", id: "openFile" },
                                      on: {
                                        change: function($event) {
                                          return _vm.clickUploadFileChange(
                                            $event
                                          )
                                        }
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "csv-item",
                                    attrs: {
                                      title: _vm.$t(
                                        "language.teamTransfer.downloadCSV"
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.downLoad()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.teamTransfer.downloadCSV"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "team-box-middle-body",
                      attrs: { id: "data-list-content" }
                    },
                    _vm._l(_vm.pair, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "middle-box",
                          class:
                            _vm.hoverIndex == index
                              ? "middle-box-background"
                              : "",
                          on: {
                            mouseover: function($event) {
                              _vm.hoverIndex = index
                            },
                            mouseleave: function($event) {
                              _vm.hoverIndex = -1
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "team-title-item",
                              staticStyle: {
                                "padding-left": "10px",
                                width: "45%"
                              }
                            },
                            [
                              item.from
                                ? _c("span", {
                                    staticClass: "icon min-type-position",
                                    class: _vm.fromDrives[0].appName + "-small"
                                  })
                                : _vm._e(),
                              item.from
                                ? _c("span", [_vm._v(_vm._s(item.from))])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "team-title-item" }, [
                            item.to
                              ? _c("span", {
                                  staticClass: "icon min-type-position",
                                  class: _vm.aimDrives[0].appName + "-small"
                                })
                              : _vm._e(),
                            item.to
                              ? _c("span", [_vm._v(_vm._s(item.to))])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "team-last-item" }, [
                            _vm.hoverIndex == index
                              ? _c("div", {
                                  staticClass: "icon-util team-transfer-close",
                                  on: {
                                    click: function($event) {
                                      return _vm.cliclRemoveItem(index)
                                    }
                                  }
                                })
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "team-transfer-box", class: _vm.boxTo },
                [
                  _c("div", { staticStyle: { height: "100%" } }, [
                    _c("div", { staticClass: "team-box-title" }, [
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "title-txt-team task-operating-none" },
                          [_vm._v(_vm._s(_vm.$t("language.cloudTransfer.to")))]
                        ),
                        _vm._v(" "),
                        _vm.aimDrives.length
                          ? _c("div", {
                              staticClass: "team-refresh icon-util edit",
                              on: {
                                click: function($event) {
                                  return _vm.transferAimDialogShow("inner")
                                }
                              }
                            })
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.aimDrives.length
                      ? _c(
                          "div",
                          { staticClass: "team-box-body" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "team-box-item",
                                staticStyle: {
                                  height: "50Px",
                                  float: "left",
                                  width: "100%"
                                }
                              },
                              [
                                _c("div", {
                                  staticClass:
                                    "task-type task-icon icon-normal-drive",
                                  class: [
                                    _vm.aimDrives.length
                                      ? _vm.aimDrives[0].appName + "_big"
                                      : ""
                                  ]
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "source-title" }, [
                                  _vm._v(_vm._s(_vm.aimDrives[0].name))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-scrollbar",
                              {
                                staticStyle: {
                                  height: "calc(100% - 50Px)",
                                  width: "100%"
                                }
                              },
                              _vm._l(_vm.aimDrives[0].data.members, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "ul",
                                  {
                                    key: index,
                                    staticClass: "team-box-item team-box-all"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "item-line",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.openAim(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "icon-util  pull-triangle-position not-open-position ",
                                          class: [
                                            item.aimOpen
                                              ? "down-triangle  down-triangle-position"
                                              : "pull-triangle"
                                          ],
                                          staticStyle: {
                                            cursor: "pointer",
                                            width: "7%",
                                            left: "10Px"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.openAim(item)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "box-litem",
                                            staticStyle: {
                                              cursor: "pointer",
                                              width: "82%",
                                              left: "10Px",
                                              position: "relative"
                                            },
                                            attrs: { title: item.domain },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.openAim(item)
                                              },
                                              dblclick: function($event) {
                                                $event.stopPropagation()
                                                return _vm.openAim(item)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(item.domain))]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(item.items, function(litem, index) {
                                      return _c(
                                        "ul",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: item.aimOpen,
                                              expression: "item.aimOpen"
                                            }
                                          ],
                                          key: index,
                                          staticClass: "team-box-item"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "item-line",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.checkAim(litem)
                                                }
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "icon-util  team-radio-position",
                                                class: [
                                                  _vm.checkAimItem == litem
                                                    ? "check-radio"
                                                    : "radio"
                                                ],
                                                staticStyle: {
                                                  "margin-left": "8%",
                                                  float: "left",
                                                  top: "14Px"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.checkAim(litem)
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "box-litem",
                                                  attrs: { title: litem.email },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.checkAim(litem)
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(litem.email) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "add-transfer-txt  team-cursor",
                            on: {
                              click: function($event) {
                                return _vm.transferAimDialogShow("out")
                              }
                            }
                          },
                          [
                            _c("div", {
                              staticClass:
                                "add-team-transfer add-team-icon-position",
                              staticStyle: { float: "left" }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "cloud-txt" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.teamTransfer.targetCloud")
                                )
                              )
                            ])
                          ]
                        )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "team-definite-operating" }, [
              _c(
                "div",
                { staticStyle: { position: "relative" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "operating-options",
                      on: {
                        click: function($event) {
                          return _vm.openOptionsDialog()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "icon-util setting",
                        staticStyle: { float: "left" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "operating-position" }, [
                        _vm._v(_vm._s(_vm.$t("language.common.options")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "operating-schedule",
                      on: {
                        click: function($event) {
                          return _vm.openSchduleDialog()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "icon-util",
                        class: _vm.checkedSchedule ? "check" : "nocheck",
                        staticStyle: { float: "left" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.checkedOpen()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "operating-position" }, [
                        _vm._v(_vm._s(_vm.$t("language.common.schedule")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("edit-input", {
                    ref: "editInput",
                    attrs: {
                      inputValue: _vm.inputValue,
                      submitTaskName: _vm.submiTransfertName
                    }
                  }),
                  _vm._v(" "),
                  !_vm.checkedSchedule
                    ? _c(
                        "button",
                        {
                          staticClass: "transfer-button",
                          on: {
                            click: function($event) {
                              return _vm.transferNow()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "icon transfer-icon-position teamTransfer"
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { float: "left" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.cloudTransfer.transferNow")
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkedSchedule
                    ? _c(
                        "div",
                        {
                          staticClass: "schedule-button",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.transferAddTask()
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "text-button-position" }, [
                            _c("div", {
                              staticClass:
                                "icon transfer-task-position cloudTransfer"
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { float: "left", color: "#fff" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.cloudTransfer.addTaskOnly")
                                  )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "more-button-position",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.addTaskIconShow()
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "icon-util  transfer-up-position",
                                class: _vm.addTaskShow
                                  ? "transfer-up"
                                  : "transfer-down"
                              })
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.addTaskShow
                    ? _c(
                        "div",
                        {
                          staticClass: "addTask",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.addTransferNow()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "task-type-icon-min transfer-blue-min transfer-blue-position"
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { float: "left" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.cloudTransfer.addTaskNow")
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "flow" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.flowShow,
                            expression: "flowShow"
                          }
                        ],
                        staticClass: "flow-icon",
                        attrs: { id: "transferFlow" }
                      },
                      [
                        _c("div", {
                          staticClass:
                            "icon transfer-task-position teamTransfer flow-icon-position"
                        })
                      ]
                    )
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "task-buttom" }),
          _vm._v(" "),
          _c("transferAimsDialog", { ref: "transferAimsDialog" }),
          _vm._v(" "),
          _c("transferSourceDialog", { ref: "transferSourceDialog" }),
          _vm._v(" "),
          _c("transferOptionsDialog", { ref: "transferOptionsDialog" }),
          _vm._v(" "),
          _c("transferScheduleDialog", { ref: "transferScheduleDialog" }),
          _vm._v(" "),
          _c("upgradeNewDialog", { ref: "upgradeNewDialog" }),
          _vm._v(" "),
          _c("noticeDialog", { ref: "noticeDialog" }),
          _vm._v(" "),
          _c("remindBindEmailDialog", { ref: "remindBindEmailDialog" }),
          _vm._v(" "),
          _c("teamNotice", { ref: "teamNotice" }),
          _vm._v(" "),
          _c("uploadCSV", { ref: "uploadCSV" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b7f4033", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b7f4033","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/team_transfer.vue
// module id = null
// module chunks = 